$shm_hitalama_settings_interface $mol_page
	title \Интерфейс
	body /
		<= Touch_hints $mol_check_box
			title \Интерактивные подсказки для тач-интерфейса (планшет/смартфон)
			checked? <=> touch_hints_enabled? true
